import { Navigate, Route, Routes } from 'react-router-dom';
import { useApp } from './lib/app-context';
import { Shell } from './components/Shell';
import { SignIn } from './routes/SignIn';
import { ModuleOverview, Modules } from './routes/Modules';
import { Exercises } from './routes/Exercises';
import { Sessions } from './routes/Sessions';
import { Programme } from './routes/Programme';
import { Studies } from './routes/Studies';
import { Skills } from './routes/Skills';
import { Publish } from './routes/Publish';

export function App() {
    const { user, ready } = useApp();

    if (!ready) return <div className="spinner">Loading…</div>;
    if (!user) return <SignIn />;

    return (
        <Routes>
            <Route element={<Shell />}>
                <Route path="/modules" element={<Modules />} />
                <Route path="/modules/:moduleId" element={<ModuleOverview />} />
                <Route path="/modules/:moduleId/exercises" element={<Exercises />} />
                <Route path="/modules/:moduleId/sessions" element={<Sessions />} />
                <Route path="/modules/:moduleId/programme" element={<Programme />} />
                <Route path="/modules/:moduleId/studies" element={<Studies />} />
                <Route path="/modules/:moduleId/skills" element={<Skills />} />
                <Route path="/modules/:moduleId/publish" element={<Publish />} />
            </Route>
            <Route path="*" element={<Navigate to="/modules" replace />} />
        </Routes>
    );
}
